import { PillRow, Skeleton, Box } from '@sequencehq/core-components'
import {
  ContractDurationSelectControl,
  CounterSignerEditorControl,
  CurrencyEditorControl,
  CustomerEditorControl,
  DealTypeEditorControl,
  EffectiveFromSelectControl,
  ExpirySelectControl,
  PaymentTermsSelectControl,
  StartDateSelectControl
} from 'modules/Cube/view/layouts/quote/QuoteEditorControls/QuoteEditorControls'
import { RecipientsEditorControl } from 'modules/Cube/view/layouts/quote/QuoteEditorControls/RecipientsSelect'
import { useQuoteEditorSidebar } from 'Cube/view/layouts/quote/QuoteEditorSidebar/useQuoteEditorSidebar'
import { CreateRecipientModal } from '../../QuoteEditorControls/CreateRecipientModal/CreateRecipientModal'
import { SelectScheduleForAmendment } from '../../QuoteEditorControls/SelectScheduleForAmendment'
import { ConfirmAmendmentChange } from '../../QuoteEditorControls/ConfirmAmendmentChange'

export const ConfigPills = () => {
  const hook = useQuoteEditorSidebar()

  return (
    <Box
      paddingLeft="18px"
      marginBottom="18px"
      zIndex={100}
      position="relative"
      data-testid="quote.configPills"
    >
      <PillRow>
        {hook.fields.customer.visible &&
          (hook.fields.customer.isLoading ? (
            <Skeleton height="24px" width="88px" />
          ) : (
            <CustomerEditorControl
              type="pill"
              data-testid="quote.customerControl"
              options={hook.fields.customer.options}
              value={hook.fields.customer.value}
              onChange={hook.fields.customer.onChange}
              disabled={hook.fields.customer.isDisabled}
              validationErrors={hook.fields.customer.validationErrors}
            />
          ))}
        {hook.fields.recipients.visible && (
          <RecipientsEditorControl
            type="pill"
            data-testid="quote.recipientsControl"
            options={hook.fields.recipients.options}
            value={hook.fields.recipients.value}
            onChange={hook.fields.recipients.onChange}
            onCreate={hook.features.createRecipient.onClick}
            validationErrors={hook.fields.recipients.validationErrors}
            disabled={hook.fields.recipients.isDisabled}
          />
        )}
        {hook.fields.counterSigners.visible && (
          <CounterSignerEditorControl
            type="pill"
            data-testid="quote.counterSignersControl"
            options={hook.fields.counterSigners.options}
            value={hook.fields.counterSigners.value}
            onChange={hook.fields.counterSigners.onChange}
            disabled={hook.fields.counterSigners.isDisabled}
            validationErrors={hook.fields.counterSigners.validationErrors}
          />
        )}
        <CurrencyEditorControl
          type="pill"
          data-testid="quote.currencyControl"
          options={hook.fields.currency.options}
          value={hook.fields.currency.value}
          onChange={hook.fields.currency.onChange}
          disabled={hook.fields.currency.isDisabled}
          validationErrors={hook.fields.currency.validationErrors}
        />
        <DealTypeEditorControl
          key={hook.fields.quoteDealType.resetKey}
          type="pill"
          data-testid="quote.dealTypeControl"
          options={hook.fields.quoteDealType.options}
          value={hook.fields.quoteDealType.value}
          onChange={hook.fields.quoteDealType.onChange}
          disabled={hook.fields.quoteDealType.isDisabled}
          validationErrors={hook.fields.quoteDealType.validationErrors}
        />
        <ExpirySelectControl
          type="pill"
          data-testid="quote.expiryControl"
          duration={hook.fields.validFor.value}
          onChange={hook.fields.validFor.onChange}
          disabled={hook.fields.validFor.isDisabled}
          validationErrors={hook.fields.validFor.validationErrors}
          labelOverride={hook.fields.validFor.labelOverride}
        />
        <ContractDurationSelectControl
          type="pill"
          data-testid="quote.contractDurationControl"
          options={hook.fields.contractLength.durations}
          duration={hook.fields.contractLength.value}
          onChange={hook.fields.contractLength.onChange}
          disabled={hook.fields.contractLength.isDisabled}
          validationErrors={hook.fields.contractLength.validationErrors}
        />
        {hook.fields.effectiveFrom.visible && (
          <EffectiveFromSelectControl
            key={`effectiveFrom-${hook.fields.effectiveFrom.resetKey}`}
            type="pill"
            data-testid="quote.effectiveFromControl"
            value={hook.fields.effectiveFrom.value}
            minDate={hook.fields.effectiveFrom.minDate}
            maxDate={hook.fields.effectiveFrom.maxDate}
            onChange={hook.fields.effectiveFrom.onChange}
            disabled={hook.fields.effectiveFrom.isDisabled}
          />
        )}
        {hook.fields.startDate.visible && (
          <StartDateSelectControl
            type="pill"
            data-testid="quote.startDateControl"
            value={hook.fields.startDate.value}
            onChange={hook.fields.startDate.onChange}
            disabled={hook.fields.startDate.isDisabled}
            validationErrors={hook.fields.startDate.validationErrors}
            optional={hook.fields.startDate.optional}
          />
        )}
        {hook.fields.defaultDueDateDays.visible && (
          <PaymentTermsSelectControl
            type="pill"
            data-testid="quote.paymentTermsControl"
            value={hook.fields.defaultDueDateDays.value}
            onChange={hook.fields.defaultDueDateDays.onChange}
            disabled={hook.fields.defaultDueDateDays.isDisabled}
            customTerms={hook.fields.defaultDueDateDays.customTerms}
          />
        )}
      </PillRow>

      {hook.modals.createRecipient.active && (
        <CreateRecipientModal onClose={hook.modals.createRecipient.onClose} />
      )}

      {hook.modals.selectScheduleForAmendment.active && (
        <SelectScheduleForAmendment
          onSubmit={hook.modals.selectScheduleForAmendment.onSubmit}
          onCancel={hook.modals.selectScheduleForAmendment.onCancel}
        />
      )}

      {hook.modals.confirmAmendmentChange.changeType && (
        <ConfirmAmendmentChange
          changeType={hook.modals.confirmAmendmentChange.changeType}
          onConfirm={hook.modals.confirmAmendmentChange.onConfirm}
          onCancel={hook.modals.confirmAmendmentChange.onCancel}
        />
      )}
    </Box>
  )
}
